import { Component, OnInit, Output, Input, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { Observable } from "rxjs";
import { HttpClient, HttpParams, HttpRequest, HttpEvent } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth';
import { finalize } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TranslateCompiler, TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';


@Component({
  selector: 'app-grades',
  templateUrl: './grades.component.html',
  styleUrls: ['./grades.component.sass']
})
export class GradesComponent implements OnInit {
  gradesListSubs: Subscription;
  grades: any;
  stages: any;
  gradesList: Grade[];
  gradeForm: FormGroup;
  isList: boolean = true;
  isNew: boolean = false;
  schoolsListSubs: Subscription;
  schools: any;
  modification_date: string;
  creation_date: string;
  grade_name: string;
  type_accept: string;
  selectedFiles: File;

  displayedColumns: string[] = ['name', 'stage', 'modification_date', 'actions'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;
  @Output() changeTab = new EventEmitter<any>();

  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public firebase: AngularFireAuth,
    private http: HttpClient,
    private translate: TranslateService,
    private snackbar: MatSnackBar
  ) { }


  public getStages(schoolID: string) {
    this.gradesListSubs = this.dataService
      .getStages(schoolID)
      .subscribe(res => {
        
        this.stages = res;
      },
        console.error
      );
  }

  //   public getSchools() {
  //     var params={};
  //     params['page'] = 1
  //     params['size'] = 100000
  //     params['search'] = ''
  //     this.schoolsListSubs = this.dataService
  //       .getSchools(params)
  //       .subscribe(res => {
  //         this.schools = res['items'];
  //           // ;
  // //           this.usersList = res;
  //         },
  //         console.error
  //       );
  //   }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.type_accept = '.pdf';
    this.gradeForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name: new FormControl('', Validators.required),
      stages: new FormControl('', Validators.required),
    });

    // this.schools = this.getSchools();
    // this.grades = this.getGrades();

    this.route.params.subscribe(params => {
      if ((params.school_id) && (params.grade_id)) {
        this.isList = false;

        this.getStages(params.school_id);
        if (params.grade_id != 'new') {
          this.isNew = false;
          this.gradesListSubs = this.dataService
            .getGrade(params.grade_id) //cambiar por id en el html
            .subscribe(res => {
              this.grades = res;
              this.gradeForm.controls["id"].setValue(this.grades.id);
              this.gradeForm.controls["name"].setValue(this.grades.name);
              this.gradeForm.controls["stages"].setValue(this.grades.stage._flat_path[1].toString());

              // this.value = `${environment.WEB_URL}/public/` + this.grades.id;
              this.modification_date = this.grades.modification_date;
              this.creation_date = this.grades.creation_date;
              this.grade_name = this.grades.name;
            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }
      }
      else {
        this.isList = true;
        if (params.id != 'new') {
          var grade_params = {}
          grade_params['school_id'] = params.id
          grade_params['stage_id'] = ''
          this.dataService.getGrades(grade_params).subscribe(grades => {
            this.grades = grades;
            this.dataSource.data = this.grades;
          });
        }
      }
    });
  }


  goTo(gradeID: string) {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl(params.id + `/grade/` + gradeID);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  goBack() {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl('school/' + params.school_id + '/2');
    });
  }

  newGrade() {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl(params.id + `/grade/new`);
    });
  }
  // csvInputChange(fileInputEvent: any) {
  // }


  saveGrade(file: any) {
    this.route.params.subscribe(url_params => {
      var params = {};
      params['name'] = this.gradeForm.controls["name"].value;
      params['id'] = this.gradeForm.controls["id"].value;
      params['school'] = url_params.school_id;
      params['stage'] = this.gradeForm.controls["stages"].value;

      if (params['name'] == '') {
        this.translate.get('alerts.name_required').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        })
        return false;
      }

      this.dataService.saveGrade(params).subscribe(data => {
        if (data == '') {
          this.goBack()
        }
        else {
          this.translate.get('alerts.grade_exists').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    })
  }

  delete(id_grade: string) {
    this.route.params.subscribe(url_params => {
      var params = {};
      params['name'] = '';
      params['id'] = id_grade;
      params['school'] = url_params.id;


      // this.dataService.deleteGrade(params).subscribe( data => {
      //   if (data == 'Grade deleted'){
      //     alert(data);
      //     window.location.reload();
      //     // this.router.navigateByUrl(`school/` + params['school']);
      //   }
      //   else{
      //     alert(data);
      //   }  
      // })
    });
  }


  changeFormat() {
    if (this.gradeForm.controls["type"].value == 'pdf') {
      this.type_accept = '.pdf';
    }
    else if (this.gradeForm.controls["type"].value == 'img') {
      this.type_accept = '.jpeg, .png, .jpg, .svg';
    }
    else {
      this.type_accept = '.mp4, .avi, .flv, .mov, .wmv, .divx';
    }

  }
}



export class Grade {
  constructor(
    public name: string,
    public type: string,
    public id: number,
    public school: string

  ) { }
}